import * as Card from '@/components/ui/card'
import { Text } from '@/components/ui/text'
import { Chat as GenericChat } from '@components'
import { useChannel } from '@features/chat/state'
import { useParams } from '@solidjs/router'
import { type Component, Show, createEffect } from 'solid-js'
import { useService } from 'solid-services'
import { Flex } from 'styled-system/jsx'
import { MessageCount } from '../../List/Card/MessageCount'
import { useSingle } from '../state'
import { useSingleChat } from '../state/singleChat'

const UsersIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.9"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    style={{ width: '14px', height: '14px' }}
  >
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
  </svg>
)

const Chat: Component = () => {
  const params = useParams()
  const { currentChannelId } = useService(useSingleChat)()
  const { setActiveChannelId, setFocusMessageId } = useService(useChannel)()
  const { subscribedCountQuery } = useService(useSingle)()

  createEffect(() => {
    setActiveChannelId(currentChannelId())
    setFocusMessageId(params.messageId)
  })

  return (
    <Card.Root
      display="grid"
      gridTemplateRows="auto 1fr"
      gap="0"
      p="0"
      overflow="hidden"
      bg="editorialPanel"
      border="1px solid var(--colors-editorial-hair)"
      borderRadius="18px"
      height={{
        base: '100%',
        xlDown: 'calc(100vh - 154px)',
        mdDown: 'calc(100vh - 110px)',
      }}
    >
      <Flex
        alignItems="center"
        justifyContent="space-between"
        px="16px"
        py="14px"
        borderBottom="1px solid var(--colors-editorial-hair)"
      >
        <Flex alignItems="center" gap="9px">
          <Text fontSize="15px" fontWeight="800" letterSpacing="-.01em" color="editorialInk">
            Discussion
          </Text>
          <MessageCount channelId={currentChannelId()} />
        </Flex>
        <Show when={subscribedCountQuery.data !== undefined}>
          <Flex alignItems="center" gap="6px" fontSize="11px" color="editorialInk3" flexShrink={0}>
            <UsersIcon />
            {subscribedCountQuery.data ?? 0} subscribed
          </Flex>
        </Show>
      </Flex>

      <GenericChat height="100%" />
    </Card.Root>
  )
}

export default Chat
